export default __webpack_public_path__ + "static/nextGenerationMechanicalPortableMobile-52fdeeeea95161862abd2c412aac627b.png";